import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import { motion } from "framer-motion";
import grupal from "../../static/media/Contacto/grupal.webp";

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

export default function ContactHeroSection() {
  const whatsappLink = `https://wa.me/593985224301?text=${encodeURIComponent(
    "Hola, quiero información sobre NovaXFit."
  )}`;

  return (
    <Box
      component="section"
      sx={{
        bgcolor: "#f3f3f4",
        py: { xs: 1.5, md: 2.5 },
      }}
    >
      <Container maxWidth="xl">
        <MotionBox
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: { xs: "24px", md: "34px" },
            background: "#0f0f10",
            boxShadow: "0 24px 60px rgba(0,0,0,0.16)",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", lg: "1.02fr 0.98fr" },
              minHeight: { xs: "auto", lg: 560 },
            }}
          >
            <MotionBox
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              sx={{
                position: "relative",
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                px: { xs: 2.2, sm: 3, md: 4.5, lg: 5.5 },
                py: { xs: 3.2, sm: 3.8, md: 4.5, lg: 5.2 },
                background:
                  "linear-gradient(135deg, #111111 0%, #161616 46%, #1d090b 100%)",
              }}
            >
              <Box sx={{ width: "100%", maxWidth: 620 }}>
                <MotionTypography
                  component="h1"
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  sx={{
                    color: "#ffffff",
                    fontWeight: 800,
                    lineHeight: { xs: 0.98, md: 0.94 },
                    letterSpacing: { xs: -1.2, md: -2 },
                    fontSize: {
                      xs: "clamp(34px, 6vw, 48px)",
                      sm: "clamp(42px, 5vw, 60px)",
                      md: "clamp(56px, 4vw, 74px)",
                    },
                  }}
                >
                  Empieza tu cambio
                  <Box
                    component="span"
                    sx={{
                      display: "block",
                      mt: 0.2,
                      color: "#e50914",
                      fontWeight: 800,
                    }}
                  >
                    con NovaXFit
                  </Box>
                </MotionTypography>

                <MotionTypography
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  sx={{
                    mt: 2,
                    maxWidth: 540,
                    color: "rgba(255,255,255,0.74)",
                    lineHeight: 1.7,
                    fontSize: { xs: 15.2, md: 17 },
                    fontWeight: 500,
                  }}
                >
                  Escríbenos por WhatsApp y recibe atención rápida para conocer
                  planes, horarios y todo lo que necesitas.
                </MotionTypography>

                <MotionBox
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  sx={{
                    mt: { xs: 2.8, md: 3.4 },
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 1.2,
                    alignItems: { xs: "stretch", sm: "center" },
                  }}
                >
                  <Button
                    component="a"
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<WhatsAppIcon />}
                    endIcon={<ArrowOutwardRoundedIcon />}
                    sx={{
                      minHeight: 52,
                      px: 2.8,
                      borderRadius: "16px",
                      textTransform: "none",
                      fontWeight: 800,
                      fontSize: 15.2,
                      color: "#ffffff",
                      background:
                        "linear-gradient(135deg, #7d0008 0%, #e50914 55%, #ff3b45 100%)",
                      boxShadow: "0 16px 34px rgba(229,9,20,0.24)",
                      "&:hover": {
                        filter: "brightness(1.05)",
                      },
                    }}
                  >
                    Escribir por WhatsApp
                  </Button>
                </MotionBox>
              </Box>
            </MotionBox>

            <MotionBox
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.2 }}
              sx={{
                position: "relative",
                minHeight: { xs: 300, sm: 340, md: 420, lg: "100%" },
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src={grupal}
                alt="Sesión grupal en NovaXFit"
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </MotionBox>
          </Box>

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: { xs: 0, lg: "48%" },
              right: 0,
              height: 4,
              background:
                "linear-gradient(90deg, #6e0007 0%, #e50914 52%, #ff4852 100%)",
            }}
          />
        </MotionBox>
      </Container>
    </Box>
  );
}